import { IStatusPanelAngularComp } from 'ag-grid-angular';
import { IStatusPanelParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { StaticFields } from './staticFields';

@Component({
    template: `
        <div class="grid" style="margin: 8px;">
            <div class="grid" style="margin: 1px;">
                <label style="cursor: pointer;" (click)="openColorSelector()" data-toggle="tooltip" data-placement="top" title="Click to Open Color Selector">
                    Set Color:  
                </label>
                <label [style.backgroundColor]="params.context.selColor === 'No Fill' ? '#ffffff' : params.context.selColor" data-toggle="tooltip" data-placement="top" title="Click to Open Color Selector" style="margin-left: 4px; width: 25px; height: 25px; border-radius: 4px; display: block; border-style: solid; border-width: 1px; cursor: pointer;" (click)="openColorSelector()"></label>
                <label for="chkHeader" class="ml-2"> Wrap Header </label>
                <p-checkbox inputId="chkHeader" (onChange)="params.context.wrapHeaderChecked($event)" [(ngModel)]="wrapHeader" [binary]="true" inputId="binary" size="large" />
                <label for="chkSel" class="ml-2"> Show Selected </label>
                <p-checkbox inputId="chkSel" (onChange)="params.context.showSelected($event)" [disabled]="params.context.disableShowSelected" [binary]="true" inputId="binary" size="large" />
                <div *ngIf="params.context.loadingCount > 0" style="margin-left: 20px;color: black;">
                    <i class="pi pi-spin pi-spinner" style="font-size: 1.2rem"></i>
                    <span class="ml-2">
                        <label style="margin-top: -10px;"> Total {{params.context.loadingCount}} records.</label>
                    </span>
                    <a (click)="params.context.cancelBatchJobs()" style="margin-left: 10px; font-size: 16px; text-decoration: underline; color: #007bff; cursor: pointer;">Cancel</a>
                </div>
            </div>
        </div>
    `,
})
export class SetCustomColorComponent implements IStatusPanelAngularComp {
    params!: IStatusPanelParams;
    selectedColor: string| undefined = "#ffffff";
    wrapHeader: boolean = false;
    
    agInit(params: IStatusPanelParams): void {
        this.params = params;
        this.wrapHeader = params.context.wrapHeader ? params.context.wrapHeader : false;
    }

    openColorSelector() {
        this.params.context.openColorSelector();
    }
}